import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Navigator } from './Navigator';
import { usePageLocale } from '../hooks/usePageLocale';

export default function Footer() {
    const data = useStaticQuery(graphql`
        query FooterQuery {
            allDatoCmsFooter {
                footerNodes: nodes {
                    locale
                    links {
                        id: originalId
                        name
                        link {
                            ... on DatoCmsImpresspage {
                                id: originalId
                            }
                            ... on DatoCmsPrivacypage {
                                id: originalId
                            }
                            ... on DatoCmsTermspage {
                                id: originalId
                            }
                        }
                    }
                }
            }
            datoCmsFooter {
                copyright
            }
            allDatoCmsImpresspage {
                impresspageNodes: nodes {
                    id: originalId
                    locale
                }
            }
            allDatoCmsPrivacypage {
                impresspageNodes: nodes {
                    id: originalId
                    locale
                }
            }
            allDatoCmsTermspage {
                impresspageNodes: nodes {
                    id: originalId
                    locale
                }
            }
            allDatoCmsServiceRecord {
                serviceRecordNodes: nodes {
                    id: originalId
                    locale
                    title
                }
            }
        }
    `)

    const {
        allDatoCmsFooter: { footerNodes },
        allDatoCmsServiceRecord: { serviceRecordNodes },
    } = data;


    const { pageLocale } = usePageLocale();

    const footerNodesMatch = footerNodes.filter(
        ({ locale }) => locale === pageLocale
    );

    const serviceRecordNodesMatch = serviceRecordNodes.filter(
        ({ locale }) => locale === pageLocale
    );

    const [{ links: footerLinks }] = footerNodesMatch;
    const [{ serviceRecordNodes: serviceRecord }] = serviceRecordNodesMatch;

    return(
        <div className='FooterWrapper'>
        {/* 
            <div className='FooterInnerWrapper'>
                <div>
                    <h3>Services</h3>
                    {serviceRecordNodes.map(({ id, title }) => (
                        <Navigator recordId={id}>
                            <span>{title}</span>
                        </Navigator>
                    ))}
                </div>
            </div>
        */}
            <div className='FooterCopyright'>
                <div className='FooterCopyrightLeft'>
                    {footerLinks.map(({ name, link }) => (
                        <Navigator recordId={link?.id} className='FooterCopyrightLinks'>
                            <a className='FooterCopyrightText'>
                                {name}
                            </a>
                        </Navigator>
                    ))}    
                </div>
                <div className='FooterCopyrightRight'>
                    <a className='FooterCopyrightText'>
                        {data.datoCmsFooter.copyright}
                    </a>
                </div>
            </div>
        </div>
    )
};